import SnackbarContainer from './SnackbarContainer'

export default SnackbarContainer



// WEBPACK FOOTER //
// ./src/containers/Snackbar/index.js